package ai.beakman.undercover.model

import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

// JS: Long "cru" vira objeto Kotlin e o Firebase Web SDK rejeita o setDoc inteiro.
// Double vira `number` JS; o SDK web grava number inteiro como integerValue (wire
// format idêntico ao dos builds mobile).
internal actual fun encodeEpochMillis(encoder: Encoder, value: Long) {
    encoder.encodeDouble(value.toDouble())
}

internal actual fun decodeEpochMillis(decoder: Decoder): Long =
    decoder.decodeDouble().toLong()
